export const lang: any = {
    jp: {
        title: '新製品発売記念キャンペーン利用規約',
        item_1: '1.キャンペーン期間：2025年9月10日（水）16:00～2025年9月30日（火）23:59',
        item_2: '*DELTA 3 MaxおよびDELTA 3 Max Plusの予約開始日は2025年9月17日（水）11:00、発売日は2025年9月24日（水）11:00です。',
        item_3: '2.初回販売台数には限りがあるため、なくなり次第一時入荷待ちとさせていただく可能性がございます。',
        item_4: '3.本ウェブサイトでご購入される場合、発送地域は日本国内のみ対象です。',
        item_5: '4.製品を安全に配送するため、ポータブル電源、ソーラーパネル、アクセサリーおよびプレゼントは別々の梱包で発送いたします。',
        item_6: '5.注文後、商品がの発送前に限りご注文のキャンセルおよび返金の申請が可能です。お客様のご都合により、購入商品到着後30日以内に返品される場合、初回取引手数料および送料をご請求させていただきますので、あらかじめご了承ください。返品・返金についての詳細は<a href="https://jp.ecoflow.com/pages/online-store-policy" target="_blank" rel="noopener noreferrer">こちら</a>をご覧ください。',
        item_7: '6.当社が必要と判断した場合、予告なくいつでも本規約の変更やキャンペーン内容の変更、停止、中止、および終了ができるものとします。それらが実施される場合には、EcoFlow公式ストアでお知らせします',
        item_8: '7.ご不明点がございましたら、弊社アフターサービス<a href="mailto:support.jp@ecoflow.com">support.jp@ecoflow.com</a>までお問い合わせください。',
    },
};
